<template>
  <Loading v-if="!fullyLoaded" />
  <SiteForm v-else :manufacturers="manufacturers" :submit="submit" :cancel="cancel" />
</template>

<script>
import CreateView from '@/mixins/createView';
import ResourceService from '@/services/resources/sites_service';
import ManufacturerService from '@/services/resources/chemical_manufacturers_service';

export default {
  mixins: [CreateView],
  components: {
    SiteForm: () => import('@/components/forms/SiteForm.vue'),
  },
  data() {
    return {
      urlFragment: 'sites',
      resourceService: ResourceService,
    };
  },
  asyncComputed: {
    manufacturers: {
      get() {
        return ManufacturerService.index().then((manufacturers) => {
          return manufacturers.data;
        });
      },
      default: [],
      shouldUpdate() {
        return this.asyncComputedShouldUpdate();
      },
    },
  },
};
</script>
